<template>
  <section>
    <div class="clearfix documentItem template-document">
      <div class="logo">
        <div class="cover-small">
          <div class="cover-image-container">
            <div class="cover-outer-align">
              <div class="cover-inner-align">
                <i class="fal fa-file-spreadsheet fa-2x" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="information w-light">
        <router-link
          :to="{ name: 'Template.Document', params: { documentId: details.template.id }}"          
        >
          <h5>{{ details.template.name }} <span v-if="details.documentVersion">- Version {{ details.documentVersion.version }}</span></h5>
        </router-link>
        <small>  <router-link
            :to="{ name: 'Template', params: { dclIdentity: details.templateDocumentVersion.dclIdentity }}"
          >
           {{ details.templateDocument.name }} {{ details.templateDocumentVersion.version }}
          </router-link></small>
        <small v-bind:class="{ 'd-block d-lg-none': !showMinimal }">
          <router-link v-if="details.documentVersion != null"
            :to="{ name: 'Template.Document', params: { documentId: details.template.id }}"
          >    {{ details.documentVersion.dclIdentity }} 
              <span v-if="details.documentVersion.publishedDate != null"> - {{ $moment(details.documentVersion.publishedDate) | moment("YYYY-MM-DD HH:mm") }}</span>
          </router-link>
        </small>
      </div>
      <div class="extrainformation w-light d-none d-lg-table-cell" v-if="!showMinimal">
        <router-link v-if="details.documentVersion != null"
            :to="{ name: 'Template.Document', params: { documentId: details.template.id }}"
          >
           {{ details.documentVersion.dclIdentity }}
          </router-link>
      </div>
      <div class="extrainformation w-light d-none d-lg-table-cell" v-if="!showMinimal">
        <router-link v-if="details.documentVersion != null"
            :to="{ name: 'Template.Document', params: { documentId: details.template.id }}"
          >
          {{ $moment(details.documentVersion.publishedDate) | moment("YYYY-MM-DD HH:mm") }}
          </router-link>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  props: ["item","small"],
  data() {
    return {
      selected: 0,
      details: this.item,
      showMinimal: this.small,
      publishedDetails: this.item,
      user: this.$store.getters["auth/user"]
    };
  },
  computed: {
    documentUrl() {
      return (
        process.env.VUE_APP_FRONTEND +
        "/template/" +
        this.details.templateDocumentVersion.dclIdentity
      );
    }
  }
};
</script>
<style>
</style>